import { render } from "./MySecurity.vue?vue&type=template&id=1428ea88&scoped=true"
import script from "./MySecurity.vue?vue&type=script&lang=js"
export * from "./MySecurity.vue?vue&type=script&lang=js"

import "./MySecurity.vue?vue&type=style&index=0&id=1428ea88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1428ea88"]])

export default __exports__